import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../context/UserProvider";
import logo from '../../assets/images/DLM-logo-shadow.png';
import imagesData from '../../assets/backgrounds/images.json';
import SuccessNotification from '../../components/toast/SuccessNotification';
import ErrorNotification from '../../components/toast/ErrorNotification';

const imageUrls = imagesData.images.map((image) =>
  require(`../../assets/backgrounds/${image}`)
);

export default function Registration() {
  const {sendBootstrap} = useContext(UserContext)
  // eslint-disable-next-line
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const navigate = useNavigate();
  const [backgroundImageIndex, setBackgroundImageIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [text, setText] = useState('');

  const closeNotification = () => {
    setShowSuccess(false);
    setShowError(false);
  };

  useEffect(() => {
    const changeBackground = () => {
      const nextIndex = (backgroundImageIndex + 1) % imageUrls.length;
      setOpacity(0);
      setTimeout(() => {
        setBackgroundImageIndex(nextIndex);
        setOpacity(1);
      }, 500);
    };
    const intervalId = setInterval(changeBackground, 10000);
    return () => clearInterval(intervalId);
  }, [backgroundImageIndex]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await sendBootstrap();
      setText('Registration successful! Please check your email for a registration message');
      setShowSuccess(true);
    } catch (err) {
      console.log('Error status:', err.response?.status);
      console.log('Error data:', err.response?.data);
      setText(err.message || 'An error occurred. Please try again.');
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="fixed left-0 top-0 z-0 h-full w-full"
        style={{
          backgroundImage: `url(${imageUrls[backgroundImageIndex]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: opacity,
          transition: 'opacity 1s ease-in-out',
        }}
      />
      <form onSubmit={handleSubmit}>
      <div className="fixed left-0 top-0 z-10 h-full w-full">
        <div className="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <img className="mx-auto h-32 w-auto" src={logo} alt="Logo" />
              <h2 className="mt-6 pt-2 text-center text-2xl font-bold text-gray-400">
                Account Information
              </h2>
              {errorMessage && (
                <p className="mt-2 text-center text-sm text-red-600">
                  {errorMessage}
                </p>
              )}
                <div>
                  <button
                    type="submit"
                    className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 mt-20px"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Updating...' : 'Send Registration'}
                  </button>
                </div>
              {showSuccess && (
                <SuccessNotification
                  show={showSuccess}
                  onClose={closeNotification}
                  text={text}
                />
              )}
              {showError && (
                <ErrorNotification
                  show={showError}
                  onClose={closeNotification}
                  text={text}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      </form>
    </>
  );
}
